export default "__VITE_ASSET__BnNU6b8n__"